import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowLeftSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="currentColor" d="M16 13.5H8a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2" />
    <path
      fill="currentColor"
      d="M10.5 16a1 1 0 0 1-.71-.29l-2.5-2.5a1 1 0 0 1 0-1.42l2.5-2.5a1.004 1.004 0 1 1 1.42 1.42l-1.8 1.79 1.8 1.79A.999.999 0 0 1 10.5 16"
    />
  </svg>
);
export default SvgArrowLeftSmall;
